import type { CityConfig } from "@/pages/city-template/types";

export const newPaltzConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "New Paltz",
  state: "New York",
  stateAbbr: "NY",
  slug: "new-paltz",
  route: "/cities/new-paltz",
  title: "Emergency Passport New Paltz, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in New Paltz, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving New Paltz, SUNY New Paltz students, Shawangunk Ridge climbers, and Hudson Valley travelers.",
  h1: "Emergency & Expedited Passport Services in New Paltz, NY",
  heroSubtitle: "SUNY New Paltz sends students to 60+ countries. The Shawangunk Ridge climbing community heads to the Alps, Patagonia, and beyond. Stewart International is 25 miles away. The Hudson Valley's outdoor and academic culture creates a passport urgency profile unlike anywhere else — and we help New Paltz residents, from SUNY students to Gardiner climbers to Wallkill Valley families, get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Breathtaking%20aerial%20view%20of%20New%20Paltz%20New%20York%20with%20the%20dramatic%20Shawangunk%20Ridge%20and%20Mohonk%20Mountain%20cliff%20faces%20at%20golden%20hour%2C%20SUNY%20New%20Paltz%20campus%20nestled%20in%20the%20Wallkill%20Valley%2C%20historic%20Huguenot%20Street%20with%20stone%20houses%2C%20autumn%20foliage%20painting%20the%20valley%20in%20warm%20colors%2C%20professional%20landscape%20photography%20with%20rich%20detail%20and%20dramatic%20sky%2C%20no%20text%20overlay&width=1800&height=700&seq=new-paltz-hero-2026&orientation=landscape",
  heroImageAlt: "New Paltz New York with Shawangunk Ridge and Mohonk cliff faces at golden hour",
  geoPosition: "41.7476;-74.0865",
  geoPlacename: "New Paltz, New York",
  lastModified: "2026-06-11",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~85 miles southeast in Manhattan — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "New Paltz", zips: "12561" },
    { name: "Kingston", zips: "12401, 12402" },
    { name: "Highland", zips: "12528" },
    { name: "Rosendale", zips: "12472" },
    { name: "Gardiner", zips: "12525" },
    { name: "Marlboro", zips: "12542" },
    { name: "Milton", zips: "12547" },
    { name: "Newburgh", zips: "12550, 12551, 12552" },
    { name: "Poughkeepsie", zips: "12601-12604" },
    { name: "Hyde Park", zips: "12538" },
    { name: "Rhinebeck", zips: "12572" },
    { name: "Woodstock", zips: "12498" },
    { name: "Albany", zips: "12201-12250" },
    { name: "New York City", zips: "10001-10282, 11201-11251" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing for Ulster County", desc: "Reserved courier access to the New York Passport Agency — as fast as 24 hours for New Paltz-area travelers with immediate departures from SWF, ALB, or JFK." },
    { icon: "ri-graduation-cap-line", title: "SUNY New Paltz Study Abroad Expertise", desc: "60+ study abroad programs across six continents. We know the 4–8 week acceptance-to-departure window and help SUNY students and faculty meet every international deadline." },
    { icon: "ri-landscape-line", title: "Shawangunk Ridge & Outdoor Adventure Travel", desc: "The Gunks climbing community heads to the Alps, Dolomites, and Patagonia. Outdoor guides, climbers, and adventure travelers have unique passport needs — and we understand them all." },
    { icon: "ri-artboard-2-line", title: "Arts, Culture & Academic Community", desc: "From Mohonk Preserve artists-in-residence to Wallkill Valley chefs heading to European kitchens, from Hudson Valley musicians to international conference presenters — New Paltz thinks globally." },
  ],
  internalLinks: [
    { name: "Fast passport services in Kingston, NY", route: "/cities/kingston" },
    { name: "Expedited passport in Poughkeepsie, NY", route: "/cities/poughkeepsie" },
    { name: "Quick passport services in Newburgh, NY", route: "/cities/newburgh" },
    { name: "Urgent passport services in New York City", route: "/cities/new-york-city" },
    { name: "New York passport services overview", route: "/newyork" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves New Paltz via secure registered courier with direct access to the New York Passport Agency at 376 Hudson Street. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. New Paltz residents can ship from any UPS Store, FedEx Office, or post office location across Ulster County.",
  fpcOfficeDistance: "Serving New Paltz, SUNY New Paltz, Gardiner, Highland, Rosendale, and all Ulster County and Wallkill Valley communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout New Paltz and all of Ulster County. From the Shawangunk Ridge to the Wallkill Valley, from the SUNY campus to Gardiner's farmlands, from Highland to Rosendale — we serve the mid-Hudson Valley with the same fast, reliable processing. Our courier service eliminates the need to drive to Manhattan for passport processing.",
  nearbyCitiesIntro: "We serve New Paltz and all Ulster County communities including Kingston, Highland, Gardiner, Rosendale, and Marlboro. We also serve SUNY New Paltz students and faculty, Shawangunk Ridge climbers, and Mohonk Preserve visitors who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in New Paltz as simple as possible — with the efficiency and reliability Hudson Valley travelers need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most New Paltz travelers — especially SUNY students — start online and ship documents overnight.",
  mistakesIntro: "New Paltz travelers encounter unique passport issues — everything from SUNY study abroad acceptance windows to climbers' water-damaged passports. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "New Paltz travelers — from SUNY students heading abroad to Gunks climbers to Mohonk Preserve artists — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in New Paltz, NY? Here are the most common ones we hear from Ulster County and Hudson Valley travelers.",
  statePageRoute: "/states/new-york",
  statePageName: "New York",
  servicesIntro: "Whether you're a SUNY New Paltz student heading to Barcelona on 4 weeks' notice, a Gunks climber departing for the Dolomites, or a Wallkill Valley family planning a first international trip — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "SUNY New Paltz study abroad orientation in Barcelona next week? Gunks climbing expedition to the Alps departing in days? Our emergency courier service submits via reserved agency slots — as fast as 24 hours.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help New Paltz residents renew fast — no agency visit required for most renewals. Perfect for SUNY faculty, Wallkill Valley professionals, and Hudson Valley families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants — especially SUNY students — require an acceptance clerk visit. We guide New Paltz residents through every step with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Climbers who lost passports on expeditions, students who misplaced documents during moves — we handle replacement with DS-64 guidance and expedited processing to get you back on track.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Hudson Valley family vacation or first international trip stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports. Common for New Paltz residents and SUNY faculty after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for SUNY faculty with overlapping conference schedules, climbing guides with back-to-back expeditions, and Hudson Valley artists with international residencies.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Water-damaged passports from climbing in the rain, coffee spills during late-night study sessions — damaged passports happen. We guide Ulster County travelers through replacement faster than you think.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Ideal for New Paltz travelers heading to Montreal or Quebec for weekend climbing trips.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport New Paltz NY", description: "Urgent passport processing for New Paltz NY travelers and SUNY New Paltz students with immediate departure needs." },
    { name: "Expedited Passport Renewal New Paltz NY", description: "Fast passport renewal for New Paltz NY residents with a previously-issued passport." },
    { name: "First-Time Passport New Paltz NY", description: "New passport application services for New Paltz NY residents and SUNY students applying for their first passport." },
    { name: "Child Passport New Paltz NY", description: "Minor passport services for New Paltz NY families with children under 16." },
    { name: "Name Change Passport New Paltz NY", description: "Passport name correction after marriage, divorce, or legal name changes for New Paltz residents." },
    { name: "Second Passport New Paltz NY", description: "Second passport services for New Paltz frequent international travelers and SUNY faculty." },
  ],
  testimonials: [
    {
      name: "Amanda S.",
      location: "SUNY New Paltz Student",
      rating: 5,
      text: "Studying abroad in Barcelona next semester. I only had 5 weeks from acceptance to departure. Fast Passport Center got my first passport processed in 5 days. They were incredibly helpful with all the student documentation requirements.",
      service: "New Passport",
    },
    {
      name: "Marcus D.",
      location: "Gardiner, NY",
      rating: 5,
      text: "The Gunks climbing guide community recommended Fast Passport Center. I needed a renewal before a Patagonia expedition and they delivered in 4 days. They understand climbers' timelines — short notice, big trips.",
      service: "Passport Renewal",
    },
    {
      name: "Professor Elena R.",
      location: "Highland, NY",
      rating: 5,
      text: "SUNY faculty heading to an academic conference in Berlin. Discovered my passport had expired just 10 days before departure. Fast Passport Center's 5-day service saved my presentation and my semester research collaboration.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "The Kim-Sullivan Family",
      location: "New Paltz, NY",
      rating: 5,
      text: "Family trip to Japan for a cousin's wedding — realized two of our passports were expired with 3 weeks to go. Fast Passport Center handled everything remotely. Both passports arrived in 5 days. Now we recommend them to everyone in the Wallkill Valley.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "newpaltz-1",
      name: "New Paltz Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2 North Chestnut Street",
      city: "New Paltz",
      state: "NY",
      zip: "12561",
      phone: "(845) 255-1100",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM (appointment required)",
      distance: "Downtown New Paltz",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Primary New Paltz passport acceptance facility. Walking distance from SUNY New Paltz campus. Extremely busy during semester start and end — book 3+ weeks ahead during peak student travel periods.",
      icon: "ri-mail-line",
    },
    {
      id: "newpaltz-2",
      name: "Kingston Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Clarence Avenue",
      city: "Kingston",
      state: "NY",
      zip: "12401",
      phone: "(845) 331-5100",
      hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM (appointment required)",
      distance: "Kingston — north of New Paltz",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Largest acceptance facility in Ulster County. More appointment slots than New Paltz. Serves Kingston, Woodstock, and northern New Paltz residents. Passport photos available.",
      icon: "ri-mail-line",
    },
    {
      id: "newpaltz-3",
      name: "Highland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2 Library Lane",
      city: "Highland",
      state: "NY",
      zip: "12528",
      phone: "(845) 691-2316",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Highland — east of New Paltz",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Convenient for Highland, Lloyd, and eastern Ulster County residents. Less crowded alternative when New Paltz post office is fully booked.",
      icon: "ri-mail-line",
    },
    {
      id: "newpaltz-4",
      name: "Rosendale Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "350 Main Street",
      city: "Rosendale",
      state: "NY",
      zip: "12472",
      phone: "(845) 658-3761",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Rosendale — north of New Paltz",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serves Rosendale, Tillson, and northern New Paltz residents. Small facility with limited appointment slots — call in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "newpaltz-5",
      name: "Gardiner Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2340 Route 44/55",
      city: "Gardiner",
      state: "NY",
      zip: "12525",
      phone: "(845) 255-7100",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Gardiner — southwest of New Paltz",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Convenient for Gardiner, Wallkill Valley, and Minnewaska area residents. Closest facility to the Shawangunk Ridge climbing community.",
      icon: "ri-mail-line",
    },
    {
      id: "newpaltz-6",
      name: "SUNY New Paltz — Center for International Programs",
      type: "University Passport Resource",
      address: "1 Hawk Drive, Student Union Building",
      city: "New Paltz",
      state: "NY",
      zip: "12561",
      phone: "(845) 257-3125",
      hours: "Mon–Fri 8:30 AM – 5:00 PM (academic year)",
      distance: "SUNY New Paltz campus",
      website: "https://www.newpaltz.edu/studyabroad/",
      websiteLabel: "SUNY New Paltz Study Abroad",
      notes: "The Center for International Programs provides study abroad guidance and can connect students with passport resources. Students should coordinate with CIP and Fast Passport Center for expedited processing.",
      icon: "ri-graduation-cap-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to New York Passport Agency in Manhattan (~85 miles)", fpc: "Most New Paltz travelers and students ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays — critical for first-time student applicants" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "SUNY & Student Travel Guidance", agency: "None — no study abroad or student-specific expertise", fpc: "Full SUNY study abroad, student first-passport, and academic travel knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Waiting for Study Abroad Acceptance Before Starting",
      description: "SUNY New Paltz students often wait until they receive their formal study abroad acceptance before starting passport paperwork — leaving only 4–8 weeks. Start your passport application the moment you apply to a program.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Climbers' Water-Damaged Passports",
      description: "Gunks climbers frequently carry passports on multi-pitch routes where rain, sweat, and chalk destroy documents. A water-damaged passport is invalid — even if barely legible. Keep your passport in a waterproof bag and replace damaged ones immediately.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "First-time applicants — the majority of SUNY students — must use DS-11 and visit an acceptance facility. Attempting the simpler DS-82 renewal form will result in rejection and lost time.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards for Outdoor Lighting",
      description: "Passport photos require specific lighting that outdoor and natural-light photos cannot meet. Do not take DIY photos at the Gunks or Mohonk. Use a professional photo service — we verify compliance before submission.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for Visa Processing After Passport Arrival",
      description: "SUNY students heading to countries requiring visas (China, Russia, Brazil) need a valid passport first, then must apply for the visa separately. Factor in an additional 2–4 weeks for visa processing after you receive your passport.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date — whether it's a study abroad deadline, climbing expedition, or family trip. Complete your secure order in minutes from your dorm or home." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist with instructions for the nearest acceptance facility — New Paltz Post Office, Kingston Main, or wherever is most convenient." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping. SUNY students can ship from the campus mail center. Most New Paltz clients ship from home." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 85 miles to Manhattan or wait at the New York Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport arrives within your chosen timeframe. Whether you're boarding a plane to Barcelona or packing climbing gear for the Dolomites — your passport is ready." },
  ],
  faqs: [
    { q: "How fast can I get a passport in New Paltz?", a: "We offer New Paltz-area clients — including SUNY students — expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors." },
    { q: "I'm a SUNY New Paltz student — can you help with study abroad passports?", a: "Absolutely. SUNY New Paltz study abroad students are one of our largest client groups. We know the 4–8 week acceptance-to-departure window and can expedite first-time and renewal passports to meet orientation and travel deadlines." },
    { q: "Where can I get passport acceptance in New Paltz?", a: "The New Paltz Post Office (2 North Chestnut Street) is walking distance from campus. Kingston Main Post Office (Clarence Avenue) has more appointment slots. Highland, Rosendale, and Gardiner post offices are also nearby alternatives." },
    { q: "Do I need to visit the New York Passport Agency in Manhattan?", a: "No. Our registered courier service handles the agency submission for you. You only need to visit a local acceptance facility (like the New Paltz Post Office) if you are a first-time applicant. Renewals typically require no in-person visit at all." },
    { q: "What about passport photos — where can I get them in New Paltz?", a: "CVS Pharmacy and Walgreens in New Paltz and Kingston offer passport photos. The UPS Store in Kingston also does photos. All photos must be 2x2 inches, white background, no glasses. We verify photo compliance before submission." },
    { q: "Can you help climbers with damaged passports?", a: "Yes — water-damaged and worn passports are common among Gunks climbers. A passport with any water damage, torn pages, or illegible data is invalid. We expedite damaged passport replacements and guide you through the process." },
    { q: "I need a visa after I get my passport — how does that work?", a: "Many SUNY study abroad destinations (China, Brazil, Russia) require visas. Once you receive your expedited passport, you apply for the visa separately. Plan for 2–4 additional weeks for visa processing. We can advise on timing based on your destination." },
    { q: "How much does an expedited passport cost in New Paltz?", a: "Government fees are $130 + $60 expedite fee. Our courier service fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% less than FedEx, Staples, and other third-party resellers." },
    { q: "Does Fast Passport Center have a New Paltz office?", a: "We operate as a remote courier service — no physical office in New Paltz, but our overnight shipping network serves Ulster County efficiently. You can complete everything from your dorm room, home, or the campus mail center." },
    { q: "What airports do New Paltz travelers use?", a: "SWF (Stewart International, 25 miles) is closest. ALB (Albany, 75 miles) and JFK (90 miles) are the primary international gateways. We coordinate passport timelines around your departure airport and flight date." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for New Paltz Residents",
    intro: "New Paltz is unlike any other Hudson Valley town — it's a college town built into a world-class climbing destination. The combination of academic calendars, expedition seasons, and arts residencies creates unique passport timing challenges.",
    cards: [
      {
        icon: "ri-graduation-cap-line",
        title: "SUNY New Paltz — The Study Abroad Engine",
        subtitle: "60+ programs across 6 continents — 4–8 week acceptance-to-departure window",
        description: "SUNY New Paltz's Center for International Programs manages one of the most active study abroad pipelines in the SUNY system. Students receive program acceptance letters and then have just 4–8 weeks to secure a passport, apply for visas, book flights, and complete pre-departure orientation. First-generation college students — a significant percentage of SUNY New Paltz's population — are often first-time passport applicants navigating the process for the first time.",
        tip: "SUNY students should start their passport application the moment they submit their study abroad application — not when they receive acceptance. The 4–8 week post-acceptance window is barely enough for standard processing and too tight if any issues arise.",
      },
      {
        icon: "ri-landscape-line",
        title: "The Gunks — Shawangunk Ridge Climbing Community",
        subtitle: "World-class climbing destination — guides, expeditions, and international climbing travel",
        description: "The Shawangunk Ridge (the Gunks) is one of the premier climbing destinations in North America, attracting climbers from around the world. The local climbing community — guides, instructors, and passionate recreational climbers — travels internationally to the Alps, Dolomites, Patagonia, and the Himalayas on expedition timelines that are often weather-dependent and booked on short notice. Climbing guides with damaged or expiring passports create a unique urgency profile.",
        tip: "Climbing guides and expedition leaders should maintain passport validity with at least 12 months remaining. Expedition opportunities often arise with 2–4 weeks notice — standard passport renewal timelines cannot accommodate this.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "SWF — Stewart International Airport",
        subtitle: "Hudson Valley's international gateway, ~25 miles from New Paltz",
        description: "Stewart International Airport in New Windsor is the closest airport to New Paltz with direct flights to Dublin, Orlando, Fort Lauderdale, and connecting service to major U.S. hubs. For international travel beyond SWF's limited routes, New Paltz travelers drive to JFK (90 miles) or ALB (75 miles). The tri-airport reality means a passport must be valid regardless of which departure point is chosen.",
        tip: "SWF's Dublin route is popular among New Paltz travelers for European connections. But if your final destination requires a connecting flight from Dublin, your passport must be valid for the entire journey — not just the SWF departure.",
      },
      {
        icon: "ri-artboard-2-line",
        title: "Mohonk Preserve & Hudson Valley Arts Community",
        subtitle: "Artists-in-residence, performers, and cultural exchange",
        description: "The Mohonk Preserve, Storm King Art Center, and numerous Hudson Valley galleries create a vibrant arts community with international connections. Artists-in-residence programs in Europe and Asia, musicians touring internationally, and culinary professionals staging in European kitchens all create passport demand from New Paltz. The arts community's project-based funding cycles mean international opportunities often materialize with limited notice.",
        tip: "Artists and performers with international residencies or tours should maintain valid passports year-round. Grant-funded international projects often have rigid start dates — a passport delay can mean losing the opportunity entirely.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "The New Paltz Paradox — World-Class Outdoor Destination, Limited Passport Infrastructure",
      description: "New Paltz attracts international travelers but has limited passport services. The New Paltz Post Office is a small facility with few appointment slots. During semester transitions (August–September, December–January), the combination of SUNY students and seasonal residents can overwhelm local acceptance facilities for weeks.",
    },
  },
  destinations: {
    title: "Where New Paltz Travelers Go — And Why Passports Get Urgent",
    intro: "New Paltz's academic, outdoor, and arts communities create a distinctive international travel profile. Here's what drives passport urgency from the Shawangunk Ridge.",
    stats: [
      { stat: "52%", label: "of New Paltz expedited requests are SUNY study abroad or academic-related" },
      { stat: "4–8 Weeks", label: "post-acceptance window SUNY students have to secure passport, visa, and travel" },
      { stat: "Aug–Sep & Jan", label: "dual peak seasons — fall semester orientation and spring semester study abroad departures" },
      { stat: "32 Hours", label: "shortest turnaround we have accommodated for a SUNY student departing to Barcelona" },
    ],
    destinations: [
      { name: "Spain", context: "SUNY Barcelona program, Madrid semester exchanges, Spanish language immersion", urgency: "Fall semester orientation deadlines in late August — peak demand in July", icon: "ri-map-pin-2-line" },
      { name: "Italy & France", context: "SUNY Florence semester, climbing trips to the Dolomites and French Alps, culinary stages", urgency: "Spring semester departures in January create December crunch", icon: "ri-map-pin-2-line" },
      { name: "Switzerland & The Alps", context: "Gunks climbers heading to the Eiger and Swiss Alps, outdoor guiding expeditions", urgency: "Summer alpine climbing season — permits and hut reservations booked months ahead", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "SUNY exchange programs, Hudson Valley artists at residencies, academic collaborations", urgency: "Visa processing adds 2–4 weeks after passport arrival", icon: "ri-map-pin-2-line" },
      { name: "Patagonia & South America", context: "Climbing expeditions to Patagonia, SUNY Chile and Argentina programs, Andes trekking", urgency: "Southern Hemisphere summer (December–February) climbing season", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Montreal and Quebec weekend climbing trips, Toronto arts and music scene", urgency: "Short-notice trips booked 1–2 weeks out — passport card ideal for land crossings", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Hudson Valley Service Areas",
    crossLinksDesc: "We serve travelers across the Hudson Valley with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Kingston", route: "/cities/kingston" },
      { name: "Newburgh", route: "/cities/newburgh" },
      { name: "Poughkeepsie", route: "/cities/poughkeepsie" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — New Paltz", address: "271 Main Street, New Paltz, NY 12561", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Kingston", address: "334 Plaza Road, Kingston, NY 12401", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "The UPS Store — Kingston", address: "1200 Ulster Avenue, Kingston, NY 12401", hours: "Call for hours", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "CVS Pharmacy — Kingston", address: "151 Ulster Avenue, Kingston, NY 12401", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Newburgh", address: "454 Broadway, Newburgh, NY 12550", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Highland", address: "3650 Route 9W, Highland, NY 12528", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "FedEx Office — Poughkeepsie", address: "2600 South Road, Poughkeepsie, NY 12601", hours: "Call for hours", website: "https://www.office.fedex.com/default/office" },
    { name: "Walmart Photo Center — Kingston", address: "601 Frank Sottile Boulevard, Kingston, NY 12401", hours: "Daily 8 AM – 10 PM", website: "https://www.walmart.com/photo" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — New Paltz",
      address: "1 South Chestnut Street, New Paltz, NY 12561",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended. Walking distance from SUNY campus.",
      featured: true,
    },
    {
      name: "NYS DMV — Kingston",
      address: "350 Washington Avenue, Kingston, NY 12401",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Full-service DMV office for Ulster County. Appointment strongly recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SWF",
      name: "New York Stewart International Airport",
      distance: "About 25 miles from New Paltz",
      address: "1 Airport Road, New Windsor, NY 12553",
      note: "Hudson Valley's primary airport with direct flights to Dublin, Orlando, Fort Lauderdale, and connecting service to major U.S. hubs. Closest airport to New Paltz.",
      flightUrl: "https://www.swcairport.com/",
      flightLabel: "Stewart Airport Website",
      featured: true,
    },
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "About 75 miles from New Paltz",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Capital Region airport with domestic flights and international connections. Alternative for northern Ulster County travelers.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport Website",
      featured: false,
    },
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "About 90 miles from New Paltz",
      address: "JFK Access Road, Jamaica, NY 11430",
      note: "NYC's primary international airport with direct flights worldwide. Most New Paltz international travelers use JFK for long-haul flights to Europe, Asia, and beyond.",
      flightUrl: "https://www.jfkairport.com/",
      flightLabel: "JFK Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the NYS Department of Health Vital Records. Online, mail, or in-person options available for Ulster County residents.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the NYS Department of Health Vital Records. Required for estate and legal matters in Ulster County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request certified marriage certificates from the Ulster County Clerk or the town clerk where the ceremony took place. Required for name change passport applications.",
      url: "https://ulstercountyny.gov/countyclerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Ulster County Supreme Court Clerk. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/",
    },
  ],
};

export default newPaltzConfig;